// src/pages/league-dashboard/team-home/PlayerNotes.js
//
// Extracted from inline definition in TeamHomeDashboard.js per Tier 2
// #9 commit 9a (refactor only — no behavior change).
import React from 'react';
import { dynastyTheme } from '../../../services/colorService';
import PlayerLink from '../../../components/PlayerLink';

const PlayerNotes = ({ notes, rosterPlayers = [] }) => {
  const safeRosterPlayers = Array.isArray(rosterPlayers) ? rosterPlayers : [];
  const safeNotes = Array.isArray(notes) ? notes : [];
  const [expandedIndex, setExpandedIndex] = React.useState(null);

  // Only include current roster players (active, bench, dl, minors) — exclude former players
  const rosterPlayerIds = safeRosterPlayers
    .filter(p => {
      const status = p.league_context?.roster?.status;
      return status && status !== 'former' && status !== 'inactive';
    })
    .map(p => p.ids?.mlb);
  const rosterNotes = safeNotes.filter(note =>
    rosterPlayerIds.includes(note.player_id)
  );

  if (!rosterNotes.length) {
    return (
      <div className={dynastyTheme.components.card.base}>
        <div className="p-3">
          <h3 className={dynastyTheme.components.heading.h3}>📰 Player Notes</h3>
          <div className={`${dynastyTheme.classes.text.neutralLight} text-center py-12`}>
            <div className="text-5xl mb-3">📰</div>
            <p className="text-lg">No recent news</p>
            <p className={`text-sm mt-2 ${dynastyTheme.classes.text.neutralLighter}`}>
              Updates about your players will appear here
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={dynastyTheme.components.card.base}>
      <div className="p-3">
        <h3 className={dynastyTheme.components.heading.h3}>📰 Player Notes</h3>
        <div className="space-y-3 max-h-80 overflow-y-auto mt-4">
          {rosterNotes.slice(0, 10).map((note, index) => {
            const isExpanded = expandedIndex === index;
            const isLong = (note.content?.length || 0) > 150;
            return (
              <div
                key={index}
                className={`
                  p-3 rounded-lg border ${dynastyTheme.classes.border.neutral}
                  bg-neutral-800/50 hover:bg-neutral-700/50
                  ${dynastyTheme.classes.transition}
                `}
              >
                <div className="flex justify-between items-start mb-2">
                  <PlayerLink
                    mlbId={note.player_id}
                    name={note.player_name}
                    style={{ fontWeight: 500, color: '#ffffff' }}
                  />
                  <span className={`
                    px-2 py-1 rounded-full text-xs font-medium
                    ${note.note_type === 'injury'
                      ? dynastyTheme.components.badge.error
                      : note.note_type === 'news'
                      ? dynastyTheme.components.badge.info
                      : dynastyTheme.components.badge.warning
                    }
                  `}>
                    {note.note_type?.toUpperCase() || 'NEWS'}
                  </span>
                </div>
                <div className={`text-sm ${dynastyTheme.classes.text.neutralLight}`}>
                  {isExpanded || !isLong
                    ? note.content
                    : `${note.content.substring(0, 150)}...`}
                </div>
                {isLong && (
                  <button
                    onClick={() => setExpandedIndex(isExpanded ? null : index)}
                    className={`text-xs mt-1 ${dynastyTheme.classes.text.primary} hover:underline`}
                  >
                    {isExpanded ? 'Show less' : 'Read more'}
                  </button>
                )}
                <div className={`text-xs ${dynastyTheme.classes.text.neutralLighter} mt-2`}>
                  {note.source || 'MLB'} • {new Date(note.date || Date.now()).toLocaleDateString()}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PlayerNotes;
